import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";
import { CatalogReferenceDataSlugs } from "~/modules/catalog/types";
import { TokenizationSponsorshipBadge } from "~/components/TokenizationSponsorshipBadge";

// // // //

export const TOKENIZATION_SPONSORSHIP_TYPE_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.tokenizationSponsorshipType,
    sortsOn: AssetColumns.tokenizationSponsorshipType,
    label: "Tokenization Sponsorship",
    tooltip: CatalogReferenceDataSlugs.tokenization_sponsorship_type,
    type: ColumnTypes.string,
    width: 180,
    render: (item, { renderOptions }) => (
        <TokenizationSponsorshipBadge
            value={item.isAsset ? item.tokenization_sponsorship_type : null}
            fullWidth={renderOptions?.fullWidth !== false}
        />
    ),
};
